let wasm;

let WASM_VECTOR_LEN = 0;

let cachedUint8ArrayMemory0 = null;

function getUint8ArrayMemory0() {
    if (cachedUint8ArrayMemory0 === null || cachedUint8ArrayMemory0.byteLength === 0) {
        cachedUint8ArrayMemory0 = new Uint8Array(wasm.memory.buffer);
    }
    return cachedUint8ArrayMemory0;
}

const cachedTextEncoder = (typeof TextEncoder !== 'undefined' ? new TextEncoder('utf-8') : { encode: () => { throw Error('TextEncoder not available') } } );

const encodeString = (typeof cachedTextEncoder.encodeInto === 'function'
    ? function (arg, view) {
    return cachedTextEncoder.encodeInto(arg, view);
}
    : function (arg, view) {
    const buf = cachedTextEncoder.encode(arg);
    view.set(buf);
    return {
        read: arg.length,
        written: buf.length
    };
});

function passStringToWasm0(arg, malloc, realloc) {

    if (realloc === undefined) {
        const buf = cachedTextEncoder.encode(arg);
        const ptr = malloc(buf.length, 1) >>> 0;
        getUint8ArrayMemory0().subarray(ptr, ptr + buf.length).set(buf);
        WASM_VECTOR_LEN = buf.length;
        return ptr;
    }

    let len = arg.length;
    let ptr = malloc(len, 1) >>> 0;

    const mem = getUint8ArrayMemory0();

    let offset = 0;

    for (; offset < len; offset++) {
        const code = arg.charCodeAt(offset);
        if (code > 0x7F) break;
        mem[ptr + offset] = code;
    }

    if (offset !== len) {
        if (offset !== 0) {
            arg = arg.slice(offset);
        }
        ptr = realloc(ptr, len, len = offset + arg.length * 3, 1) >>> 0;
        const view = getUint8ArrayMemory0().subarray(ptr + offset, ptr + len);
        const ret = encodeString(arg, view);

        offset += ret.written;
        ptr = realloc(ptr, len, offset, 1) >>> 0;
    }

    WASM_VECTOR_LEN = offset;
    return ptr;
}

function isLikeNone(x) {
    return x === undefined || x === null;
}

let cachedDataViewMemory0 = null;

function getDataViewMemory0() {
    if (cachedDataViewMemory0 === null || cachedDataViewMemory0.buffer.detached === true || (cachedDataViewMemory0.buffer.detached === undefined && cachedDataViewMemory0.buffer !== wasm.memory.buffer)) {
        cachedDataViewMemory0 = new DataView(wasm.memory.buffer);
    }
    return cachedDataViewMemory0;
}

const cachedTextDecoder = (typeof TextDecoder !== 'undefined' ? new TextDecoder('utf-8', { ignoreBOM: true, fatal: true }) : { decode: () => { throw Error('TextDecoder not available') } } );

if (typeof TextDecoder !== 'undefined') { cachedTextDecoder.decode(); };

function getStringFromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    return cachedTextDecoder.decode(getUint8ArrayMemory0().subarray(ptr, ptr + len));
}
/**
 * @returns {SharedConstants}
 */
export function loadRiskEngineConstants() {
    const ret = wasm.loadRiskEngineConstants();
    return SharedConstants.__wrap(ret);
}

/**
 * Calculates the Black-Scholes-Merton option price and its Greeks.
 *
 * # Parameters
 * * `currentStockPrice`: The current stock price.
 * * `strikePrice`: The strike price of the option.
 * * `timeToExpiration`: The time to expiration in years.
 * * `riskFreeInterestRate`: The risk-free interest rate.
 * * `dividendYield`: The dividend yield of the underlying asset.
 * * `volatility`: The volatility of the underlying asset.
 * * `isCall`: A boolean indicating whether the option is a call option.
 *
 * # Returns
 * A `BlackScholesResult` struct containing the option price and its Greeks.
 * @param {number} currentStockPrice
 * @param {number} strikePrice
 * @param {number} timeToExpiration
 * @param {number} riskFreeInterestRate
 * @param {number} dividendYield
 * @param {number} volatility
 * @param {boolean} isCall
 * @returns {BlackScholesResult}
 */
export function blackScholesMerton(currentStockPrice, strikePrice, timeToExpiration, riskFreeInterestRate, dividendYield, volatility, isCall) {
    const ret = wasm.blackScholesMerton(currentStockPrice, strikePrice, timeToExpiration, riskFreeInterestRate, dividendYield, volatility, isCall);
    return BlackScholesResult.__wrap(ret);
}

let cachedFloat64ArrayMemory0 = null;

function getFloat64ArrayMemory0() {
    if (cachedFloat64ArrayMemory0 === null || cachedFloat64ArrayMemory0.byteLength === 0) {
        cachedFloat64ArrayMemory0 = new Float64Array(wasm.memory.buffer);
    }
    return cachedFloat64ArrayMemory0;
}

function passArrayF64ToWasm0(arg, malloc) {
    const ptr = malloc(arg.length * 8, 8) >>> 0;
    getFloat64ArrayMemory0().set(arg, ptr / 8);
    WASM_VECTOR_LEN = arg.length;
    return ptr;
}
/**
 * Calculates the option price using a binomial tree model.
 *
 * # Parameters
 * * `currentStockPrice`: The current stock price.
 * * `strikePrice`: The strike price of the option.
 * * `timeToExpiration`: The time to expiration in years.
 * * `riskFreeInterestRate`: The risk-free interest rate.
 * * `dividendYield`: The dividend yield of the underlying asset.
 * * `volatility`: The volatility of the underlying asset.
 * * `isCall`: A boolean indicating whether the option is a call option.
 * * `dividendDates`: A vector of dividend dates as annualized years until the event.
 * * `dividendAmounts`: A vector of dividend amounts corresponding to the dates.
 *
 * # Returns
 * The calculated option price.
 * @param {number} currentStockPrice
 * @param {number} strikePrice
 * @param {number} timeToExpiration
 * @param {number} riskFreeInterestRate
 * @param {number} dividendYield
 * @param {number} volatility
 * @param {boolean} isCall
 * @param {Float64Array} dividendDates
 * @param {Float64Array} dividendAmounts
 * @returns {number}
 */
export function binomialTree(currentStockPrice, strikePrice, timeToExpiration, riskFreeInterestRate, dividendYield, volatility, isCall, dividendDates, dividendAmounts) {
    const ptr0 = passArrayF64ToWasm0(dividendDates, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passArrayF64ToWasm0(dividendAmounts, wasm.__wbindgen_malloc);
    const len1 = WASM_VECTOR_LEN;
    const ret = wasm.binomialTree(currentStockPrice, strikePrice, timeToExpiration, riskFreeInterestRate, dividendYield, volatility, isCall, ptr0, len0, ptr1, len1);
    return ret;
}

function addToExternrefTable0(obj) {
    const idx = wasm.__externref_table_alloc();
    wasm.__wbindgen_export_0.set(idx, obj);
    return idx;
}

function passArrayJsValueToWasm0(array, malloc) {
    const ptr = malloc(array.length * 4, 4) >>> 0;
    for (let i = 0; i < array.length; i++) {
        const add = addToExternrefTable0(array[i]);
        getDataViewMemory0().setUint32(ptr + 4 * i, add, true);
    }
    WASM_VECTOR_LEN = array.length;
    return ptr;
}

function getArrayF64FromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    return getFloat64ArrayMemory0().subarray(ptr / 8, ptr / 8 + len);
}
/**
 * Calculates the implied volatilities for a set of options.
 *
 * # Parameters
 * * `currentStockPrice`: The current stock price.
 * * `strikePrices`: A vector of strike prices for the options.
 * * `optionPrices`: A vector of option prices corresponding to the strike prices.
 * * `timeToExpiration`: The time to expiration in years.
 * * `riskFreeInterestRate`: The risk-free interest rate.
 * * `dividendYield`: The dividend yield of the underlying asset.
 * * `currentDate`: A Unix timestamp representing the starting date in seconds, or 0 if not used.
 * * `additionalHolidays`: A vector of strings representing additional holidays in the format "YYYY-MM-DD`.`
 * * `useSvi`: A boolean indicating whether to use the stochastic volatility inspired model to fit a smooth IV curve.
 *
 * # Returns
 * A vector of implied volatilities corresponding to the input options.
 * @param {number} currentStockPrice
 * @param {Float64Array} strikePrices
 * @param {Float64Array} optionPrices
 * @param {number} timeToExpiration
 * @param {number} riskFreeInterestRate
 * @param {number} dividendYield
 * @param {number} currentDate
 * @param {string[]} additionalHolidays
 * @param {boolean} useSVI
 * @returns {Float64Array}
 */
export function calculateImpliedVolatilities(currentStockPrice, strikePrices, optionPrices, timeToExpiration, riskFreeInterestRate, dividendYield, currentDate, additionalHolidays, useSVI) {
    const ptr0 = passArrayF64ToWasm0(strikePrices, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passArrayF64ToWasm0(optionPrices, wasm.__wbindgen_malloc);
    const len1 = WASM_VECTOR_LEN;
    const ptr2 = passArrayJsValueToWasm0(additionalHolidays, wasm.__wbindgen_malloc);
    const len2 = WASM_VECTOR_LEN;
    const ret = wasm.calculateImpliedVolatilities(currentStockPrice, ptr0, len0, ptr1, len1, timeToExpiration, riskFreeInterestRate, dividendYield, currentDate, ptr2, len2, useSVI);
    var v4 = getArrayF64FromWasm0(ret[0], ret[1]).slice();
    wasm.__wbindgen_free(ret[0], ret[1] * 8, 8);
    return v4;
}

/**
 * Calculates the implied volatilities for a set of options.
 *
 * # Parameters
 * * `currentStockPrice`: The current stock price.
 * * `strikePrices`: A vector of strike prices for the options.
 * * `optionPrices`: A vector of option prices corresponding to the strike prices.
 * * `timeToExpiration`: The time to expiration in years.
 * * `riskFreeInterestRate`: The risk-free interest rate.
 * * `dividendYield`: The dividend yield of the underlying asset.
 * * `currentDate`: A Unix timestamp representing the starting date in seconds, or 0 if not used.
 * * `additionalHolidays`: A vector of strings representing additional holidays in the format "YYYY-MM-DD`.`
 * * `optionType`: An enum indicating whether the option is a call or put.
 *
 * # Returns
 * A vector of implied volatilities corresponding to the input options.
 * @param {number} currentStockPrice
 * @param {Float64Array} strikePrices
 * @param {Float64Array} optionPrices
 * @param {number} timeToExpiration
 * @param {number} riskFreeInterestRate
 * @param {number} dividendYield
 * @param {number} currentDate
 * @param {string[]} additionalHolidays
 * @param {OptionType} optionType
 * @returns {Float64Array}
 */
export function calculateImpliedVolatilitiesWithOptionType(currentStockPrice, strikePrices, optionPrices, timeToExpiration, riskFreeInterestRate, dividendYield, currentDate, additionalHolidays, optionType) {
    const ptr0 = passArrayF64ToWasm0(strikePrices, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passArrayF64ToWasm0(optionPrices, wasm.__wbindgen_malloc);
    const len1 = WASM_VECTOR_LEN;
    const ptr2 = passArrayJsValueToWasm0(additionalHolidays, wasm.__wbindgen_malloc);
    const len2 = WASM_VECTOR_LEN;
    const ret = wasm.calculateImpliedVolatilitiesWithOptionType(currentStockPrice, ptr0, len0, ptr1, len1, timeToExpiration, riskFreeInterestRate, dividendYield, currentDate, ptr2, len2, optionType);
    var v4 = getArrayF64FromWasm0(ret[0], ret[1]).slice();
    wasm.__wbindgen_free(ret[0], ret[1] * 8, 8);
    return v4;
}

function takeFromExternrefTable0(idx) {
    const value = wasm.__wbindgen_export_0.get(idx);
    wasm.__externref_table_dealloc(idx);
    return value;
}
/**
 * Calculates the variance time based on a given calendar model.
 *
 * # Parameters
 * * `startingTimestamp`: A Unix timestamp representing the starting date in seconds.
 * * `additionalHolidays`: A vector of strings representing additional holidays in the format "YYYY-MM-DD".
 * * `elapsedSeconds`: The number of seconds to go forward from the date.
 * * `model`: The calendar model to use (either `CalendarDayModel` or `BusinessDayModel`.
 *
 * # Returns
 * The calculated variance time.
 * @param {number} startingTimestamp
 * @param {string[]} additionalHolidays
 * @param {number} elapsedSeconds
 * @param {number} model
 * @returns {number}
 */
export function calculateVarianceTime(startingTimestamp, additionalHolidays, elapsedSeconds, model) {
    const ptr0 = passArrayJsValueToWasm0(additionalHolidays, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.calculateVarianceTime(startingTimestamp, ptr0, len0, elapsedSeconds, model);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return ret[0];
}

/**
 * @enum {0 | 1}
 */
export const OptionType = Object.freeze({
    Call: 0, "0": "Call",
    Put: 1, "1": "Put",
});
/**
 * @enum {0 | 1}
 */
export const VarianceTimeCalendarModel = Object.freeze({
    CalendarDayModel: 0, "0": "CalendarDayModel",
    BusinessDayModel: 1, "1": "BusinessDayModel",
});

const BlackScholesResultFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_blackscholesresult_free(ptr >>> 0, 1));

export class BlackScholesResult {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(BlackScholesResult.prototype);
        obj.__wbg_ptr = ptr;
        BlackScholesResultFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        BlackScholesResultFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_blackscholesresult_free(ptr, 0);
    }
    /**
     * @returns {number}
     */
    get price() {
        const ret = wasm.__wbg_get_blackscholesresult_price(this.__wbg_ptr);
        return ret;
    }
    /**
     * @param {number} arg0
     */
    set price(arg0) {
        wasm.__wbg_set_blackscholesresult_price(this.__wbg_ptr, arg0);
    }
    /**
     * @returns {number}
     */
    get delta() {
        const ret = wasm.__wbg_get_blackscholesresult_delta(this.__wbg_ptr);
        return ret;
    }
    /**
     * @param {number} arg0
     */
    set delta(arg0) {
        wasm.__wbg_set_blackscholesresult_delta(this.__wbg_ptr, arg0);
    }
    /**
     * @returns {number}
     */
    get gamma() {
        const ret = wasm.__wbg_get_blackscholesresult_gamma(this.__wbg_ptr);
        return ret;
    }
    /**
     * @param {number} arg0
     */
    set gamma(arg0) {
        wasm.__wbg_set_blackscholesresult_gamma(this.__wbg_ptr, arg0);
    }
    /**
     * @returns {number}
     */
    get vega() {
        const ret = wasm.__wbg_get_blackscholesresult_vega(this.__wbg_ptr);
        return ret;
    }
    /**
     * @param {number} arg0
     */
    set vega(arg0) {
        wasm.__wbg_set_blackscholesresult_vega(this.__wbg_ptr, arg0);
    }
    /**
     * @returns {number}
     */
    get theta() {
        const ret = wasm.__wbg_get_blackscholesresult_theta(this.__wbg_ptr);
        return ret;
    }
    /**
     * @param {number} arg0
     */
    set theta(arg0) {
        wasm.__wbg_set_blackscholesresult_theta(this.__wbg_ptr, arg0);
    }
    /**
     * @returns {number}
     */
    get rho() {
        const ret = wasm.__wbg_get_blackscholesresult_rho(this.__wbg_ptr);
        return ret;
    }
    /**
     * @param {number} arg0
     */
    set rho(arg0) {
        wasm.__wbg_set_blackscholesresult_rho(this.__wbg_ptr, arg0);
    }
}

const SharedConstantsFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_sharedconstants_free(ptr >>> 0, 1));

export class SharedConstants {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(SharedConstants.prototype);
        obj.__wbg_ptr = ptr;
        SharedConstantsFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        SharedConstantsFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_sharedconstants_free(ptr, 0);
    }
    /**
     * @returns {number}
     */
    get ADJUSTED_DAYS_IN_YEAR() {
        const ret = wasm.__wbg_get_blackscholesresult_price(this.__wbg_ptr);
        return ret;
    }
    /**
     * @param {number} arg0
     */
    set ADJUSTED_DAYS_IN_YEAR(arg0) {
        wasm.__wbg_set_blackscholesresult_price(this.__wbg_ptr, arg0);
    }
    /**
     * @returns {number}
     */
    get SECONDS_PER_DAY() {
        const ret = wasm.__wbg_get_sharedconstants_SECONDS_PER_DAY(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
     * @param {number} arg0
     */
    set SECONDS_PER_DAY(arg0) {
        wasm.__wbg_set_sharedconstants_SECONDS_PER_DAY(this.__wbg_ptr, arg0);
    }
}

async function __wbg_load(module, imports) {
    if (typeof Response === 'function' && module instanceof Response) {
        if (typeof WebAssembly.instantiateStreaming === 'function') {
            try {
                return await WebAssembly.instantiateStreaming(module, imports);

            } catch (e) {
                if (module.headers.get('Content-Type') != 'application/wasm') {
                    console.warn("`WebAssembly.instantiateStreaming` failed because your server does not serve Wasm with `application/wasm` MIME type. Falling back to `WebAssembly.instantiate` which is slower. Original error:\n", e);

                } else {
                    throw e;
                }
            }
        }

        const bytes = await module.arrayBuffer();
        return await WebAssembly.instantiate(bytes, imports);

    } else {
        const instance = await WebAssembly.instantiate(module, imports);

        if (instance instanceof WebAssembly.Instance) {
            return { instance, module };

        } else {
            return instance;
        }
    }
}

function __wbg_get_imports() {
    const imports = {};
    imports.wbg = {};
    imports.wbg.__wbindgen_init_externref_table = function() {
        const table = wasm.__wbindgen_export_0;
        const offset = table.grow(4);
        table.set(0, undefined);
        table.set(offset + 0, undefined);
        table.set(offset + 1, null);
        table.set(offset + 2, true);
        table.set(offset + 3, false);
        ;
    };
    imports.wbg.__wbindgen_string_get = function(arg0, arg1) {
        const obj = arg1;
        const ret = typeof(obj) === 'string' ? obj : undefined;
        var ptr1 = isLikeNone(ret) ? 0 : passStringToWasm0(ret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len1 = WASM_VECTOR_LEN;
        getDataViewMemory0().setInt32(arg0 + 4 * 1, len1, true);
        getDataViewMemory0().setInt32(arg0 + 4 * 0, ptr1, true);
    };
    imports.wbg.__wbindgen_string_new = function(arg0, arg1) {
        const ret = getStringFromWasm0(arg0, arg1);
        return ret;
    };
    imports.wbg.__wbindgen_throw = function(arg0, arg1) {
        throw new Error(getStringFromWasm0(arg0, arg1));
    };

    return imports;
}

function __wbg_init_memory(imports, memory) {

}

function __wbg_finalize_init(instance, module) {
    wasm = instance.exports;
    __wbg_init.__wbindgen_wasm_module = module;
    cachedDataViewMemory0 = null;
    cachedFloat64ArrayMemory0 = null;
    cachedUint8ArrayMemory0 = null;


    wasm.__wbindgen_start();
    return wasm;
}

function initSync(module) {
    if (wasm !== undefined) return wasm;


    if (typeof module !== 'undefined') {
        if (Object.getPrototypeOf(module) === Object.prototype) {
            ({module} = module)
        } else {
            console.warn('using deprecated parameters for `initSync()`; pass a single object instead')
        }
    }

    const imports = __wbg_get_imports();

    __wbg_init_memory(imports);

    if (!(module instanceof WebAssembly.Module)) {
        module = new WebAssembly.Module(module);
    }

    const instance = new WebAssembly.Instance(module, imports);

    return __wbg_finalize_init(instance, module);
}

async function __wbg_init(module_or_path) {
    if (wasm !== undefined) return wasm;


    if (typeof module_or_path !== 'undefined') {
        if (Object.getPrototypeOf(module_or_path) === Object.prototype) {
            ({module_or_path} = module_or_path)
        } else {
            console.warn('using deprecated parameters for the initialization function; pass a single object instead')
        }
    }

    if (typeof module_or_path === 'undefined') {
        module_or_path = new URL('sg_risk_engine_bg.wasm', import.meta.url);
    }
    const imports = __wbg_get_imports();

    if (typeof module_or_path === 'string' || (typeof Request === 'function' && module_or_path instanceof Request) || (typeof URL === 'function' && module_or_path instanceof URL)) {
        module_or_path = fetch(module_or_path);
    }

    __wbg_init_memory(imports);

    const { instance, module } = await __wbg_load(await module_or_path, imports);

    return __wbg_finalize_init(instance, module);
}

export { initSync };
export default __wbg_init;
